import { fbt } from 'fbtee'
import { Unlink } from 'lucide-react'
import { DropdownMenuItem } from '../../components/ui/dropdown-menu'
import { SocialEventCard } from '../../components/SocialEventCard'
import type { EventInterestStatus } from '../../hooks/useUserEventInterests'
import type { FriendEventInterestBuckets } from '../../hooks/useFriendEventInterests'
import type { Event, UserProfile } from '../../types'

/** `disabled`: the viewer may not unlink this one (not an admin, and it's someone else's link or others reacted). */
export function UnlinkMenuItem({ onUnlink, disabled }: { onUnlink: () => void; disabled?: boolean }) {
  return (
    <DropdownMenuItem variant="destructive" onSelect={onUnlink} disabled={disabled}>
      <Unlink />
      {disabled
        ? fbt('Only admins can unlink this', 'Disabled menu item on a group event a non-admin can no longer unlink')
        : fbt('Unlink', 'Menu item to unlink an event from a group')}
    </DropdownMenuItem>
  )
}

/** A linked event in the group's lists: the event card with members' facepile and the viewer's RSVP. */
export function LinkedEventCard({
  event,
  buckets,
  profiles,
  locale,
  status,
  onOpen,
  onSetStatus,
  onUnlink,
  unlinkDisabled,
}: {
  event: Event
  buckets: FriendEventInterestBuckets | undefined
  profiles: Record<string, UserProfile>
  locale: string
  status: EventInterestStatus
  onOpen: () => void
  onSetStatus?: (status: EventInterestStatus) => void
  /** Omit for guests — they can RSVP but not unlink. */
  onUnlink?: () => void
  unlinkDisabled?: boolean
}) {
  const going = buckets?.going ?? []
  const interested = buckets?.interested ?? []
  return (
    <SocialEventCard
      event={event}
      facepile={{ userIds: [...going, ...interested], goingUserIds: new Set(going) }}
      profiles={profiles}
      locale={locale}
      status={status}
      onOpen={onOpen}
      onSetStatus={onSetStatus}
      menuFooter={onUnlink ? <UnlinkMenuItem onUnlink={onUnlink} disabled={unlinkDisabled} /> : undefined}
    />
  )
}
